<template>
  <div>
    <div class="error-code">404</div>
    <div class="error-msg">
      抱歉，您访问的页面不存在或已被删除！
    </div>
  </div>
</template>

<script>
export default {
  name: "404"
};
</script>

<style scoped>
.error-code {
  color: #009688;
  font-size: 150px;
  text-align: center;
  font-weight: bold;
}
.error-msg {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/error/404.vue